"use client";
import { Box, Spinner, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useGetImagePrompt } from "queries";
import { GET_USERNAME_BY_FILENAME } from "api";
import { fetch } from "libs";

// components/PromptTooltip.tsx
const PromptTooltip = ({
  fileName,
  isFlux = false,
  onUsernameFetch,
  onPromptFetch,
}: {
  fileName: string;
  isFlux?: boolean;
  onUsernameFetch?: (username: string) => void;
  onPromptFetch?: (prompt: string) => void;
}) => {
  const finalFileName = isFlux
    ? fileName.split("/").pop() || fileName
    : fileName;

  const { data: promptData } = useGetImagePrompt(finalFileName, isFlux);
  const [username, setUsername] = useState<string | null>(null);

  useEffect(() => {
    const getUsername = async () => {
      try {
        const response = await fetch(GET_USERNAME_BY_FILENAME(fileName));
        setUsername(response.username || null);
        if (response.username && onUsernameFetch) {
          onUsernameFetch(response.username); // ✅ Pass it back to parent
        }
      } catch (e) {
        setUsername(null);
      }
    };
  
    getUsername();
  }, [fileName]);
  
  useEffect(() => {
    if (promptData?.prompt && onPromptFetch) {
      onPromptFetch(promptData.prompt);
    }
  }, [promptData, onPromptFetch]);

  return (
    <Box
      position="absolute"
      bottom="0"
      left="0"
      right="0"
      bgGradient="linear(to-t, rgba(0,0,0,0.8), transparent)"
      p="3"
      color="white"
      fontSize="sm"
      maxH="120px"
      overflow="hidden"
      opacity={0}
      transition="opacity 0.2s"
      _groupHover={{ opacity: 1 }}
    >
      {username && (
        <Text fontWeight="bold" fontSize="medium" color="#FF1B6D" mb="1">
          {username}
        </Text>
      )}
      <Text>{promptData?.prompt || "No prompt found"}</Text>
    </Box>
  );
};

export default PromptTooltip;
